import { AstroidProductPresentationDto } from '../services/astroidProductPresentation/dto/astroidProductPresentationDto';
import AstroidProductPresentationService from '../services/astroidProductPresentation/astroidProductPresentationService';
import { PolicyType } from '../services/policy/policyTypeEnums';
import { CrudStoreBase } from './crudStoreBase';

class AstroidProductPresentationStore extends CrudStoreBase<AstroidProductPresentationDto>{
  constructor() {
    super(AstroidProductPresentationService, defaultAstroidProductPresentation)
  }
}

export const defaultAstroidProductPresentation: AstroidProductPresentationDto = {
  id: '',
  product: PolicyType.Vehicle,
  insurer: "",
  variant: "",
  sections: "",
  creationTime: "",
  lastModificationTime: "",
}

export default AstroidProductPresentationStore;
